import app from 'flarum/forum/app';
import Avatar from 'flarum/common/components/Avatar';
import Link from 'flarum/common/components/Link';
export default class FeedbackUserDisplay {
  static getUserInfo(props) {
    let displayName = props.displayName || String(app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_item.unknown_user'));
    let avatarColor = props.avatarColor || '#888';
    let avatarUrl = props.avatarUrl || null;
    let fromUser;

    // Try to get from included users first
    if (props.userId) {
      if (props.includedUsers) {
        const userData = props.includedUsers.get(String(props.userId));
        if (userData) {
          displayName = userData.displayName || userData.username || app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_item.user_id_format', {
            id: props.userId
          });
          avatarUrl = userData.avatarUrl;
        }
      }

      // Try to get from store
      fromUser = app.store.getById('users', String(props.userId));
      if (fromUser) {
        displayName = fromUser.displayName() || displayName;
        avatarColor = fromUser.color() || avatarColor;
        avatarUrl = fromUser.avatarUrl() || avatarUrl;
      }
    }
    return {
      displayName,
      avatarColor,
      avatarUrl,
      fromUser
    };
  }
  static view(props) {
    const {
      displayName,
      avatarColor,
      avatarUrl,
      fromUser
    } = this.getUserInfo(props);
    const userProfileLink = fromUser ? app.route.user(fromUser) : null;
    const avatarElement = fromUser ? m(Avatar, {
      user: fromUser,
      className: "FeedbackItem-avatar"
    }) : avatarUrl ? m("img", {
      className: "Avatar FeedbackItem-avatar",
      src: avatarUrl,
      alt: displayName
    }) : m("span", {
      className: "Avatar FeedbackItem-avatar",
      style: {
        '--avatar-bg': avatarColor
      }
    }, displayName[0]?.toUpperCase() || '?');
    const usernameElement = m("span", {
      className: "FeedbackItem-username"
    }, displayName);
    if (userProfileLink) {
      return m("div", {
        className: "FeedbackItem-user"
      }, m(Link, {
        href: userProfileLink,
        className: "FeedbackItem-userLink"
      }, avatarElement), m(Link, {
        href: userProfileLink,
        className: "FeedbackItem-userLink"
      }, usernameElement));
    }
    return m("div", {
      className: "FeedbackItem-user"
    }, avatarElement, usernameElement);
  }
}
flarum.reg.add('huseyinfiliz-traderfeedback', 'forum/components/TraderFeedback/FeedbackUserDisplay', FeedbackUserDisplay);